import {dashboardViewRegionsUniqueStateId} from './dashboard-view-regions.model';
import {DashboardViewRegion} from '../../types/dashboard-view-regions.types';

export class SelectViewRegion {
  static readonly type = `${dashboardViewRegionsUniqueStateId} ${SelectViewRegion.name}`;

  constructor(public viewRegionId: DashboardViewRegion['id']) {}
}

export class SelectDefaultViewRegion {
  static readonly type = `${dashboardViewRegionsUniqueStateId} ${SelectDefaultViewRegion.name}`;
}


